import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Rating/Rating.js",
    _this = this;

import React from 'react';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { withTheme } from '../../core/ThemeProvider';
import useDevice from '../../core/hooks/useDevice';
import Star from './star.svg';
import StarFilled from './star_filled.svg';
import StarFilledHalf from './star_filled_half.svg';
var RatingContainer = styled.div.withConfig({
  displayName: "Rating__RatingContainer",
  componentId: "sc-lnlyan-0"
})(["display:flex;align-items:center;"]);
var TotalText = withTheme(styled(Text).withConfig({
  displayName: "Rating__TotalText",
  componentId: "sc-lnlyan-1"
})(["display:inline-block;color:", ";padding-left:", "px;"], function (p) {
  return p.coreTheme.cl_ter_l3;
}, function (p) {
  return p.coreTheme.space_1;
}));
var IconWrapper = withTheme(styled.span.withConfig({
  displayName: "Rating__IconWrapper",
  componentId: "sc-lnlyan-2"
})(function (_ref) {
  var coreTheme = _ref.coreTheme,
      size = _ref.size;
  return css(["padding-right:", "px;svg{height:", "px;min-height:", "px;width:", "px;}"], coreTheme.space_1, size, size, size);
}));

var Rating = function Rating(props) {
  var value = props.value,
      maxValue = props.maxValue,
      total = props.total;

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile,
      isTablet = _useDevice.isTablet,
      isLandscapeTablet = _useDevice.isLandscapeTablet;

  var iMaxValue = parseInt(maxValue, 10);
  var iconSize = isMobile || isTablet ? 16 : isLandscapeTablet ? 18 : 20;
  return /*#__PURE__*/React.createElement(RatingContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }, _toConsumableArray(Array(iMaxValue)).map(function (_, i) {
    var isWholeStar = value >= i + 1;
    var isHalfStar = value >= i + 0.5;
    var StarIcon;
    var iconName;

    if (isWholeStar) {
      StarIcon = StarFilled;
      iconName = 'star_filled';
    } else if (isHalfStar) {
      StarIcon = StarFilledHalf;
      iconName = 'star_filled_half';
    } else {
      StarIcon = Star;
      iconName = 'star';
    }

    return /*#__PURE__*/React.createElement(IconWrapper, {
      key: i,
      "data-testid": "rating-stars",
      size: iconSize,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(StarIcon, {
      "data-testid": "rating-stars-".concat(iconName),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 13
      }
    }));
  }), !!total && /*#__PURE__*/React.createElement(TotalText, {
    type: "body",
    lineHeight: "compact",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, "(", total, ")"));
};

Rating.defaultProps = {
  value: 0,
  maxValue: 5,
  total: 0
};
export default Rating;